import isNil from "lodash/isNil";

export const currencyFormatter = (amount, maximumFractionDigits = 0) => {
  return !isNil(amount) ? new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: 0,
  }).format(amount) : ''
}